import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { GlobalStoreService } from '../../services/global-store/global-store.service';
import { ErreurMappingService } from '../../services/errors/erreur-mapping.service';
import { AccessibiliteService } from '../../services/accessibilite.service';
import { FormulaireFiservService } from 'src/app/services/formulaire-fiserv/formulaire-fiserv.service';
import { FormulaireBancaireService } from 'src/app/services/formulaire-bancaire/formulaire-bancaire.service';
import {CybermetrieCoordonneesService} from "../../services/cybermetrie/cybermetrie.service";

@Component({
  selector: 'app-modale-annuler',
  templateUrl: './modale-annuler.component.html',
  standalone: false,
})
export class ModaleAnnulerComponent implements OnInit {
  showValue = false;
  constructor(
    readonly navigationService: NavigationService,
    readonly erreurMappingCanadaForm: ErreurMappingService,
    readonly accessibiliteService: AccessibiliteService,
    readonly globalStoreService: GlobalStoreService,
    private readonly formulaireFiservService: FormulaireFiservService,
    private readonly formulaireBancaireService: FormulaireBancaireService,
    private readonly cybermetrieCoordonneesService: CybermetrieCoordonneesService
  ) {}

  ngOnInit(): void {
    this.globalStoreService.getEtatModale().subscribe((etat) => (this.showValue = etat));
  }

  @HostListener('window:oel-header-transactionnel.boutonRetourCliquee')
  handleBoutonAnnulerHeader(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }
  showDialog() {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(false);
  }
  redirectionAccueil() {
    this.formulaireBancaireService.setForm(null);
    this.formulaireFiservService.setForm(null);
    this.globalStoreService.saveUpdateDataForm(null);
    this.erreurMappingCanadaForm.resetFormsError();
    this.globalStoreService.saveEtatAfficherModaleAnnuler(false);
    this.accessibiliteService.setFocus('h1');
    this.navigationService.naviguerVersAccueil();
    this.cybermetrieCoordonneesService.clickAnnulerCoordonneesBancaire(this.globalStoreService.getDeclancherModale());
  }
}
